(()=>{
  const $=(selector,context=document)=>context.querySelector(selector);
  const $$=(selector,context=document)=>[...context.querySelectorAll(selector)];

  // Mobile navigation
  const menuButton=$('[data-menu-toggle]');
  const mobileMenu=$('[data-mobile-menu]');
  if(menuButton&&mobileMenu){
    menuButton.addEventListener('click',()=>{
      const isOpen=mobileMenu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded',String(isOpen));
    });
  }

  // Cart drawer UI. Cart mutations use Shopify's standard storefront actions when available.
  const drawer=$('[data-cart-drawer]');
  const openDrawer=()=>{
    if(!drawer)return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('cart-drawer-open');
  };
  const closeDrawer=()=>{
    if(!drawer)return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('cart-drawer-open');
  };

  $$('[data-cart-open]').forEach(button=>button.addEventListener('click',async event=>{
    event.preventDefault();
    if(window.Shopify?.actions?.openCart){
      try{await window.Shopify.actions.openCart();return;}catch(error){console.warn('Shopify openCart failed; using theme drawer.',error)}
    }
    openDrawer();
  }));
  $$('[data-cart-close]').forEach(button=>button.addEventListener('click',closeDrawer));
  document.addEventListener('keydown',event=>{if(event.key==='Escape')closeDrawer()});

  const money=cents=>{
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'en',{
        style:'currency',
        currency:window.themeRoutes?.currency||window.Shopify?.currency?.active||'USD'
      }).format(Number(cents||0)/100);
    }catch(error){return (Number(cents||0)/100).toFixed(2)}
  };
  const escapeHtml=(value='')=>String(value).replace(/[&<>'"]/g,char=>({
    '&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'
  }[char]));

  function updateCartCount(count){
    $$('[data-cart-count]').forEach(element=>{
      const value=Number(count||0);
      element.textContent=String(value);
      element.dataset.count=String(value);
      element.hidden=value===0;
    });
  }

  function renderCart(cart){
    updateCartCount(cart.item_count);
    const items=$('[data-drawer-items]');
    const total=$('[data-drawer-total]');
    if(items){
      items.innerHTML=cart.items.length?cart.items.map((item,index)=>`<div class="drawer-item" data-cart-line="${index+1}" data-cart-line-id="${escapeHtml(item.key||'')}">
        <a class="drawer-item__image" href="${escapeHtml(item.url)}">${item.image?`<img src="${escapeHtml(item.image)}" alt="">`:''}</a>
        <div class="drawer-item__body">
          <a class="drawer-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${item.variant_title&&item.variant_title!=='Default Title'?`<div class="drawer-item__variant">${escapeHtml(item.variant_title)}</div>`:''}
          <div class="drawer-item__bottom"><div class="drawer-quantity"><button type="button" data-cart-minus aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-plus aria-label="Increase quantity">+</button></div><strong>${money(item.final_line_price)}</strong></div>
          <button type="button" class="drawer-remove" data-cart-remove>${escapeHtml(window.themeStrings?.remove||'Remove')}</button>
        </div>
      </div>`).join(''):`<div class="drawer-empty">${escapeHtml(items.dataset.empty)}</div>`;
    }
    if(total)total.textContent=money(cart.total_price);
  }

  async function refreshCart(){
    const base=window.themeRoutes?.cartJson;
    if(!base)throw new Error('Cart route is unavailable');
    const url=base+(base.includes('?')?'&':'?')+'_='+Date.now();
    const response=await fetch(url,{headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('Unable to refresh cart');
    const cart=await response.json();
    renderCart(cart);
    return cart;
  }

  async function changeCartFallback(line,quantity){
    const response=await fetch(window.themeRoutes.cartChange,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({line,quantity})
    });
    if(!response.ok)throw await response.json();
    const cart=await response.json();
    renderCart(cart);
    return cart;
  }

  async function updateLine(item,quantity){
    const lineId=item.dataset.cartLineId;
    const lineNumber=Number(item.dataset.cartLine);
    if(window.Shopify?.actions?.updateCart&&lineId){
      const result=await window.Shopify.actions.updateCart(
        {lines:[{id:lineId,quantity}]},
        {event:{context:'cart',detail:{source:'kyosi-cart-drawer'}}}
      );
      if(result?.userErrors?.length)throw new Error(result.userErrors[0].message);
      await refreshCart();
      return;
    }
    if(!lineNumber)throw new Error('Cart line is unavailable');
    await changeCartFallback(lineNumber,quantity);
  }

  document.addEventListener('click',async event=>{
    const item=event.target.closest('[data-cart-line]');
    if(!item)return;
    const current=Number($('.drawer-quantity span',item)?.textContent||1);
    let quantity=null;
    if(event.target.closest('[data-cart-minus]'))quantity=Math.max(0,current-1);
    if(event.target.closest('[data-cart-plus]'))quantity=current+1;
    if(event.target.closest('[data-cart-remove]'))quantity=0;
    if(quantity===null)return;
    event.preventDefault();
    const panel=$('.cart-drawer__panel');
    panel?.classList.add('is-loading');
    try{await updateLine(item,quantity)}
    catch(error){console.warn('Cart update failed',error)}
    finally{panel?.classList.remove('is-loading')}
  });

  // Product forms: keep Shopify's native product form markup, and use the standard updateCart action.
  $$('form[data-product-form]').forEach(form=>{
    const quantityInput=$('[data-qty-input]',form);
    const quantityLabel=$('[data-quantity-label]',form);
    const setQuantity=value=>{
      if(!quantityInput)return;
      const quantity=Math.max(1,parseInt(value,10)||1);
      quantityInput.value=String(quantity);
      if(quantityLabel)quantityLabel.textContent=String(quantity);
    };
    $('[data-qty-minus]',form)?.addEventListener('click',()=>setQuantity((parseInt(quantityInput.value,10)||1)-1));
    $('[data-qty-plus]',form)?.addEventListener('click',()=>setQuantity((parseInt(quantityInput.value,10)||1)+1));
    quantityInput?.addEventListener('change',()=>setQuantity(quantityInput.value));

    form.addEventListener('submit',async event=>{
      // If standard actions are not available, let Shopify's native product form submit normally.
      if(!window.Shopify?.actions?.updateCart)return;
      event.preventDefault();
      const button=$('[data-product-submit]',form);
      const errorBox=$('[data-form-error]',form);
      if(button){button.disabled=true;button.classList.add('is-loading')}
      if(errorBox){errorBox.hidden=true;errorBox.style.display='none';errorBox.textContent=''}

      try{
        const formData=new FormData(form);
        const merchandiseId=String(formData.get('id')||'');
        const quantity=Math.max(1,parseInt(formData.get('quantity'),10)||1);
        if(!merchandiseId)throw new Error('Please select an available option.');

        const line={merchandiseId,quantity};
        const sellingPlanId=formData.get('selling_plan');
        if(sellingPlanId)line.sellingPlanId=String(sellingPlanId);
        const attributes=[];
        for(const [name,value] of formData.entries()){
          const match=/^properties\[(.+)\]$/.exec(name);
          if(match&&String(value)!=='')attributes.push({key:match[1],value:String(value)});
        }
        if(attributes.length)line.attributes=attributes;

        const result=await window.Shopify.actions.updateCart(
          {lines:[line]},
          {event:{context:'product',detail:{source:'kyosi-product-form'}}}
        );
        if(result?.userErrors?.length)throw new Error(result.userErrors[0].message);
        await refreshCart();
        if(window.Shopify?.actions?.openCart){
          try{await window.Shopify.actions.openCart()}catch(error){openDrawer()}
        }else openDrawer();
      }catch(error){
        if(errorBox){
          errorBox.textContent=error?.message||'Unable to add to cart';
          errorBox.hidden=false;
          errorBox.style.display='block';
        }
      }finally{
        if(button){button.disabled=false;button.classList.remove('is-loading')}
      }
    });
  });

  // Variant selector. Real radio inputs keep the UI keyboard-accessible and reduce JS-only state.
  $$('[data-product-root]').forEach(root=>{
    const dataElement=$('[data-variants-json]',root);
    if(!dataElement)return;
    let variants=[];
    try{variants=JSON.parse(dataElement.textContent)}catch(error){return}

    const groups=$$('[data-option-index]',root);
    const hiddenVariant=$('[data-variant-id]',root);
    const price=$('[data-product-price]',root);
    const comparePrice=$('[data-compare-price]',root);
    const discountBadge=$('[data-discount-badge]',root);
    const submit=$('[data-product-submit]',root);
    const summary=$('[data-selection-summary]',root);

    function syncVariant(){
      const selected=groups.map(group=>$('[data-option-input]:checked',group)?.value).filter(value=>value!==undefined);
      groups.forEach(group=>{
        const checked=$('[data-option-input]:checked',group);
        const selectedLabel=$('[data-selected-option]',group);
        $$('[data-option-button]',group).forEach(label=>label.classList.toggle('is-active',label.htmlFor===checked?.id));
        if(selectedLabel&&checked)selectedLabel.textContent=checked.value;
      });
      if(summary)summary.textContent=selected.filter(Boolean).join(' · ');

      const variant=variants.find(candidate=>candidate.options.every((option,index)=>option===selected[index]));
      if(variant&&hiddenVariant){
        hiddenVariant.value=variant.id;
        if(price)price.textContent=money(variant.price);

        const currentPrice=Number(variant.price||0);
        const originalPrice=Number(variant.compare_at_price||0);
        const isDiscounted=originalPrice>currentPrice;
        if(comparePrice){
          comparePrice.hidden=!isDiscounted;
          comparePrice.textContent=isDiscounted?money(originalPrice):'';
        }
        if(discountBadge){
          discountBadge.hidden=!isDiscounted;
          discountBadge.textContent=isDiscounted?`${Math.round(((originalPrice-currentPrice)/originalPrice)*100)}% OFF`:'';
        }

        if(submit){
          submit.disabled=!variant.available;
          submit.textContent=variant.available?submit.dataset.add:submit.dataset.sold;
        }
        try{
          const url=new URL(window.location.href);
          url.searchParams.set('variant',variant.id);
          history.replaceState({},'',url);
        }catch(error){}
        root.dispatchEvent(new CustomEvent('kyosi:variant-change',{bubbles:true,detail:{variant}}));
      }else if(submit){
        submit.disabled=true;
        submit.textContent=submit.dataset.sold;
      }
    }

    groups.forEach(group=>$$('[data-option-input]',group).forEach(input=>input.addEventListener('change',syncVariant)));
    syncVariant();
  });

  // Expose only the small cart refresh surface needed by theme integrations.
  window.KYOSI=Object.assign(window.KYOSI||{},{refreshCart,openDrawer,closeDrawer});
})();

// Product media gallery: stable one-source-of-truth sync for desktop + mobile.
(()=>{
  document.querySelectorAll('[data-product-root]').forEach(productRoot=>{
    const gallery=productRoot.querySelector('[data-product-gallery]');
    if(!gallery)return;

    const main=gallery.querySelector('[data-gallery-main]');
    const thumbsContainer=gallery.querySelector('[data-gallery-thumbs]');
    const thumbs=[...gallery.querySelectorAll('[data-media-target]')];
    const items=[...gallery.querySelectorAll('.product-gallery__item[data-media-id]')];
    if(!main||!thumbsContainer||!thumbs.length||!items.length)return;

    const mobile=()=>window.matchMedia('(max-width: 749px)').matches;
    let currentIndex=Math.max(0,items.findIndex(item=>item.classList.contains('is-active')));
    let rafId=0;
    let programmaticTarget=null;
    let programmaticTimer=0;

    function stopMedia(item){
      if(!item)return;
      item.querySelectorAll('video').forEach(video=>{
        try{video.pause()}catch(error){}
      });
      item.querySelectorAll('iframe').forEach(frame=>{
        try{
          frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), '*');
          frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), '*');
        }catch(error){}
      });
    }

    function keepThumbVisible(index,behavior='smooth'){
      const thumb=thumbs[index];
      if(!thumb)return;
      if(mobile()){
        const left=thumb.offsetLeft-(thumbsContainer.clientWidth-thumb.offsetWidth)/2;
        thumbsContainer.scrollTo({left:Math.max(0,left),behavior});
      }else{
        const top=thumb.offsetTop-(thumbsContainer.clientHeight-thumb.offsetHeight)/2;
        thumbsContainer.scrollTo({top:Math.max(0,top),behavior});
      }
    }

    function setVisualState(index,{scrollThumb=true,behavior='smooth'}={}){
      index=Math.max(0,Math.min(items.length-1,Number(index)||0));
      const previous=currentIndex;
      currentIndex=index;

      items.forEach((item,i)=>{
        const active=i===index;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-hidden',active?'false':'true');
        if(!active||i===previous&&previous!==index)stopMedia(item);
      });
      if(previous!==index)stopMedia(items[previous]);

      thumbs.forEach((thumb,i)=>{
        const active=i===index;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-current',active?'true':'false');
      });
      if(scrollThumb)keepThumbVisible(index,behavior);
    }

    function scrollMainTo(index,behavior='smooth'){
      if(!mobile())return;
      const left=index*main.clientWidth;
      programmaticTarget=index;
      clearTimeout(programmaticTimer);
      programmaticTimer=setTimeout(()=>{programmaticTarget=null},700);
      main.scrollTo({left,behavior});
    }

    function selectIndex(index,{scrollMain=false,scrollThumb=true,behavior='smooth'}={}){
      index=Math.max(0,Math.min(items.length-1,Number(index)||0));
      setVisualState(index,{scrollThumb,behavior});
      if(scrollMain)scrollMainTo(index,behavior);
    }

    function nearestIndex(){
      if(!main.clientWidth)return currentIndex;
      return Math.max(0,Math.min(items.length-1,Math.round(main.scrollLeft/main.clientWidth)));
    }

    // Event delegation keeps thumbnail clicks reliable even when the active media is a playing video.
    thumbsContainer.addEventListener('click',event=>{
      const thumb=event.target.closest('[data-media-target]');
      if(!thumb||!thumbsContainer.contains(thumb))return;
      event.preventDefault();
      const index=Number(thumb.dataset.mediaIndex ?? thumbs.indexOf(thumb));
      // Pause the currently playing media before changing slides.
      stopMedia(items[currentIndex]);
      selectIndex(index,{scrollMain:mobile(),scrollThumb:true,behavior:'smooth'});
    });

    main.addEventListener('scroll',()=>{
      if(!mobile())return;
      if(rafId)cancelAnimationFrame(rafId);
      rafId=requestAnimationFrame(()=>{
        const index=nearestIndex();
        // During a thumbnail-initiated smooth scroll, keep the requested thumbnail active
        // until the requested slide arrives. This prevents the old video thumbnail from
        // immediately stealing the active state back while the gallery is animating.
        if(programmaticTarget!==null){
          if(index===programmaticTarget){
            programmaticTarget=null;
            clearTimeout(programmaticTimer);
            setVisualState(index,{scrollThumb:true,behavior:'smooth'});
          }
          return;
        }
        if(index!==currentIndex){
          stopMedia(items[currentIndex]);
          setVisualState(index,{scrollThumb:true,behavior:'smooth'});
        }
      });
    },{passive:true});

    if('onscrollend' in window){
      main.addEventListener('scrollend',()=>{
        if(!mobile())return;
        const index=programmaticTarget!==null?programmaticTarget:nearestIndex();
        programmaticTarget=null;
        clearTimeout(programmaticTimer);
        setVisualState(index,{scrollThumb:true,behavior:'smooth'});
      },{passive:true});
    }

    productRoot.addEventListener('kyosi:variant-change',event=>{
      const mediaId=String(event.detail?.variant?.featured_media?.id||'');
      if(!mediaId)return;
      const index=items.findIndex(item=>item.dataset.mediaId===mediaId);
      if(index>=0){
        stopMedia(items[currentIndex]);
        selectIndex(index,{scrollMain:mobile(),scrollThumb:true,behavior:'smooth'});
      }
    });

    window.addEventListener('resize',()=>{
      programmaticTarget=null;
      clearTimeout(programmaticTimer);
      if(mobile()){
        main.scrollTo({left:currentIndex*main.clientWidth,behavior:'auto'});
      }
      setVisualState(currentIndex,{scrollThumb:false,behavior:'auto'});
    });

    setVisualState(currentIndex,{scrollThumb:false,behavior:'auto'});
    if(mobile())main.scrollTo({left:currentIndex*main.clientWidth,behavior:'auto'});
  });
})();

// KYOSI Announcement Slider
(()=>{
 const initAnnouncementSlider=(slider)=>{
  if(!slider)return;
  if(slider._kyosiAnnouncementTimer){clearInterval(slider._kyosiAnnouncementTimer);slider._kyosiAnnouncementTimer=null;}
  const slides=[...slider.querySelectorAll('[data-announcement-slide]')];
  if(!slides.length)return;
  let index=Math.max(0,slides.findIndex(slide=>slide.classList.contains('is-active')));
  slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));
  if(slides.length<2)return;
  const speed=Math.max(2,Math.min(10,Number(slider.dataset.speed)||4))*1000;
  slider._kyosiAnnouncementTimer=setInterval(()=>{
    slides[index].classList.remove('is-active');
    index=(index+1)%slides.length;
    slides[index].classList.add('is-active');
  },speed);
 };
 const initAll=()=>document.querySelectorAll('[data-announcement-slider]').forEach(initAnnouncementSlider);
 initAll();
 document.addEventListener('shopify:section:load',event=>{
  event.target?.querySelectorAll?.('[data-announcement-slider]').forEach(initAnnouncementSlider);
 });
 document.addEventListener('shopify:block:select',event=>{
  const slide=event.target?.matches?.('[data-announcement-slide]')?event.target:event.target?.closest?.('[data-announcement-slide]');
  if(!slide)return;
  const slider=slide.closest('[data-announcement-slider]');
  if(!slider)return;
  if(slider._kyosiAnnouncementTimer){clearInterval(slider._kyosiAnnouncementTimer);slider._kyosiAnnouncementTimer=null;}
  slider.querySelectorAll('[data-announcement-slide]').forEach(item=>item.classList.toggle('is-active',item===slide));
 });
})();

// KYOSI Welcome Offer Popup
(()=>{
  const initPopup=(popup)=>{
    if(!popup || popup.dataset.kyosiPopupReady==='true') return;
    popup.dataset.kyosiPopupReady='true';
    const dialog=popup.querySelector('.kyosi-welcome-popup__dialog');
    const email=popup.querySelector('[data-welcome-popup-email]');
    const closeButtons=[...popup.querySelectorAll('[data-welcome-popup-close]')];
    const copyButton=popup.querySelector('[data-welcome-popup-copy]');
    const code=popup.querySelector('[data-welcome-popup-code]');
    const delay=Math.max(0,Number(popup.dataset.delay)||0)*1000;
    const repeatDays=Math.max(1,Number(popup.dataset.repeatDays)||1);
    const storageKey='kyosiWelcomePopupClosed:'+popup.dataset.sectionId;
    const isSuccess=popup.dataset.formSuccess==='true';
    const designMode=!!window.Shopify?.designMode;
    let openTimer=null;

    const recentlyClosed=()=>{
      if(designMode || isSuccess) return false;
      try{
        const closedAt=Number(localStorage.getItem(storageKey)||0);
        return closedAt>0 && (Date.now()-closedAt)<repeatDays*86400000;
      }catch(e){return false;}
    };
    const open=()=>{
      if(!popup.hidden) return;
      popup.hidden=false;
      document.body.classList.add('kyosi-popup-open');
      requestAnimationFrame(()=>{
        if(isSuccess) dialog?.focus();
        else (email||dialog)?.focus();
      });
    };
    const close=(remember=true)=>{
      popup.hidden=true;
      document.body.classList.remove('kyosi-popup-open');
      if(remember && !designMode){try{localStorage.setItem(storageKey,String(Date.now()));}catch(e){}}
    };

    closeButtons.forEach(btn=>btn.addEventListener('click',()=>close(true)));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!popup.hidden) close(true)});
    if(copyButton && code){
      copyButton.addEventListener('click',async()=>{
        const value=code.textContent.trim();
        try{await navigator.clipboard.writeText(value);}catch(e){
          const temp=document.createElement('textarea');temp.value=value;document.body.appendChild(temp);temp.select();document.execCommand('copy');temp.remove();
        }
        copyButton.textContent=copyButton.dataset.copiedLabel||'COPIED';
        setTimeout(()=>{copyButton.textContent=copyButton.dataset.copyLabel||'COPY CODE'},1600);
      });
    }

    if(isSuccess || designMode) openTimer=setTimeout(open,designMode?250:0);
    else if(!recentlyClosed()) openTimer=setTimeout(open,delay);

    document.addEventListener('shopify:section:select',event=>{
      if(event.detail?.sectionId===popup.dataset.sectionId){clearTimeout(openTimer);open();}
    });
    document.addEventListener('shopify:section:deselect',event=>{
      if(event.detail?.sectionId===popup.dataset.sectionId) close(false);
    });
  };

  document.querySelectorAll('[data-welcome-popup]').forEach(initPopup);
  document.addEventListener('shopify:section:load',event=>{
    event.target?.querySelectorAll?.('[data-welcome-popup]').forEach(initPopup);
  });
})();


// KYOSI Apple Watch size guide modal (watch-band template only)
(()=>{
  const getOpenModal=()=>document.querySelector('[data-size-guide]:not([hidden])');
  const closeModal=(modal)=>{
    if(!modal || modal.hidden) return;
    modal.hidden=true;
    if(!getOpenModal()) document.body.classList.remove('kyosi-size-guide-open');
    const opener=modal._kyosiSizeGuideOpener;
    if(opener && opener.isConnected) opener.focus({preventScroll:true});
  };
  const openModal=(button)=>{
    const modal=document.getElementById(button.dataset.sizeGuideOpen);
    if(!modal) return;
    const alreadyOpen=getOpenModal();
    if(alreadyOpen && alreadyOpen!==modal) closeModal(alreadyOpen);
    modal._kyosiSizeGuideOpener=button;
    modal.hidden=false;
    document.body.classList.add('kyosi-size-guide-open');
    requestAnimationFrame(()=>modal.querySelector('[data-size-guide-dialog]')?.focus({preventScroll:true}));
  };
  document.addEventListener('click',event=>{
    const openButton=event.target.closest?.('[data-size-guide-open]');
    if(openButton){event.preventDefault();openModal(openButton);return;}
    const closeButton=event.target.closest?.('[data-size-guide-close]');
    if(closeButton){closeModal(closeButton.closest('[data-size-guide]'));}
  });
  document.addEventListener('keydown',event=>{
    const modal=getOpenModal();
    if(!modal) return;
    if(event.key==='Escape'){
      event.preventDefault();
      closeModal(modal);
      return;
    }
    if(event.key==='Tab'){
      const dialog=modal.querySelector('[data-size-guide-dialog]');
      const focusable=[...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')];
      if(!focusable.length){event.preventDefault();dialog.focus();return;}
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
  document.addEventListener('shopify:section:unload',event=>{
    const modal=event.target?.querySelector?.('[data-size-guide]');
    if(modal && !modal.hidden) closeModal(modal);
  });
})();
